import { Star, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import { useFrequentlyUsedNavigation, FrequentlyUsedItem } from '@/hooks/useFrequentlyUsedNavigation';
import { useState } from 'react';

export function FrequentlyUsedSection() {
  const location = useLocation();
  const { frequentlyUsedItems, isLoading, settings } = useFrequentlyUsedNavigation();
  const [isOpen, setIsOpen] = useState(true);

  // Don't render if disabled or no items
  if (!settings.enabled || isLoading || frequentlyUsedItems.length === 0) {
    return null;
  }

  const renderIcon = (item: FrequentlyUsedItem) => {
    if (!item.icon) return <Star className="h-4 w-4 text-primary" />;
    
    if (typeof item.icon === 'string') {
      return <img src={item.icon} alt="" className="h-4 w-4 object-contain" />;
    }
    
    const Icon = item.icon;
    return <Icon className="h-4 w-4 text-primary" />;
  };

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <SidebarGroup className="py-2 border-b border-sidebar-border">
        <CollapsibleTrigger asChild>
          <SidebarGroupLabel className="cursor-pointer hover:bg-sidebar-accent hover:text-sidebar-accent-foreground rounded-md flex items-center justify-between text-sm font-medium">
            <div className="flex items-center gap-2">
              <Star className="h-4 w-4 text-amber-500 fill-amber-500" />
              <span>Frequently Used</span>
            </div>
            <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
          </SidebarGroupLabel>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <SidebarGroupContent>
            <SidebarMenu>
              {frequentlyUsedItems.map((item) => {
                const isActive = location.pathname === item.path;
                
                return (
                  <SidebarMenuItem key={item.id}>
                    <SidebarMenuButton 
                      asChild 
                      isActive={isActive}
                      tooltip={`${item.label} (${item.clickCount} visits)`}
                    >
                      <Link to={item.path}>
                        {renderIcon(item)}
                        <span>{item.label}</span>
                      </Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  );
}
